import React from "react";
import PropTypes from "prop-types";

import {
    spacingSizes,
    headingSizes,
    alignments,
    headingTypes
} from "core/props";

import { MaterialUIGridContainer } from "core/MaterialUI";

import ImageOnLeft from "./ImageOnLeft";
import ImageOnRight from "./ImageOnRight";

const CollectionSpotlight = ({
    buttonProps,
    headingType,
    headingSize,
    headingAlignment,
    headingTopSpacing,
    headingBottomSpacing,
    headingColor,
    isRightImg,
    image,
    imageCaption,
    imageAlt,
    collectionHeading,
    collectionText,
    collectionLink,
    sideBySideContentOnMedium,
    isBottomImageOnMobile
}) => {
    const mediumScreenSizeGridSpan = sideBySideContentOnMedium ? 6 : 12;

    return (
        <MaterialUIGridContainer
            mobileMaxPadding={0}
            tabletMaxPadding={sideBySideContentOnMedium ? 3 : 0}
            desktopMinPadding={0}
            // we are handling the padding via CSS for this component because MaterialUI does not "let" us use 128px for padding when passed in, and that's what this needs on desktop.
            alignItems="center"
        >
            {isRightImg ? (
                <ImageOnRight
                    image={image}
                    imageAlt={imageAlt}
                    imageCaption={imageCaption}
                    headingType={headingType}
                    headingSize={headingSize}
                    headingAlignment={headingAlignment}
                    headingTopSpacing={headingTopSpacing}
                    headingBottomSpacing={headingBottomSpacing}
                    headingColor={headingColor}
                    collectionHeading={collectionHeading}
                    collectionText={collectionText}
                    mediumScreenSizeGridSpan={mediumScreenSizeGridSpan}
                    sideBySideContentOnMedium={sideBySideContentOnMedium}
                    isBottomImageOnMobile={isBottomImageOnMobile}
                    collectionLink={collectionLink}
                    buttonProps={buttonProps}
                />
            ) : (
                <ImageOnLeft
                    image={image}
                    imageAlt={imageAlt}
                    imageCaption={imageCaption}
                    headingType={headingType}
                    headingSize={headingSize}
                    headingAlignment={headingAlignment}
                    headingTopSpacing={headingTopSpacing}
                    headingBottomSpacing={headingBottomSpacing}
                    headingColor={headingColor}
                    collectionHeading={collectionHeading}
                    collectionText={collectionText}
                    mediumScreenSizeGridSpan={mediumScreenSizeGridSpan}
                    collectionLink={collectionLink}
                    buttonProps={buttonProps}
                />
            )}
        </MaterialUIGridContainer>
    );
};

CollectionSpotlight.propTypes = {
    buttonProps: PropTypes.object,
    headingType: PropTypes.oneOf(headingTypes),
    headingSize: PropTypes.oneOf(headingSizes),
    headingAlignment: PropTypes.oneOf(alignments),
    headingTopSpacing: PropTypes.oneOf(spacingSizes),
    headingBottomSpacing: PropTypes.oneOf(spacingSizes),
    headingColor: PropTypes.string,
    isRightImg: PropTypes.bool,
    image: PropTypes.string.isRequired,
    imageCaption: PropTypes.string,
    imageAlt: PropTypes.string.isRequired,
    collectionHeading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    collectionText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    collectionLink: PropTypes.array,
    sideBySideContentOnMedium: PropTypes.bool,
    isBottomImageOnMobile: PropTypes.bool
};

export default CollectionSpotlight;
